<template>
    <v-dialog v-model="dialog" persistent max-width="450">
        <v-card>
            <v-card-title
                class="text-h5 aviso"
                style="
                    justify-content: center;
                    background: #1d2735;
                    color: white;
                "
            >
                {{ titulo }}
            </v-card-title>
            <v-card-text class="pa-4">
                <h2 class="text-center">{{ texto }}</h2>
            </v-card-text>
            <v-card-actions class="d-flex justify-center">
                <v-btn color="error" class="white--text" large @click="close"
                    >Cancelar</v-btn
                >
                <v-btn color="green" class="white--text" large @click="confirm"
                    >Confirmar</v-btn
                >
            </v-card-actions>
        </v-card>
    </v-dialog>
</template>

<script>
export default {
    props: ["value", "titulo", "texto", "data"],
    name: "v-confirm-dialog",
    data() {
        return {
            dialog: false,
            itemData: null,
        };
    },
    created() {
        if (this.data != null) {
            this.itemData = this.data;
        }
        // this.$parent.$on('open', () => this.dialog = true)
    },
    methods: {
        confirm() {
            this.dialog = false;
            this.$emit("confirm", this.itemData?.new);
        },
        close() {
            this.dialog = false;
            this.$emit("confirm", this.itemData?.same);
        },
    },
    watch: {
        value(newVal) {
            this.dialog = newVal;
        },
        dialog(newVal) {
            this.$emit("input", newVal);
        },
        data(newVal) {
            if (newVal != null) {
                this.itemData = newVal;
            }
        },
    },
};
</script>
